// Guardian Tape – Variant Sync Fix v5
// Runs AFTER Seal re-renders, using MutationObserver + post-morph timing
(function () {

  var variantPrices = {
    '47983631532132': { oneTime: 'A$44.44',  sub: 'A$44.44'  },  // 1 Month
    '47951846539364': { oneTime: 'A$99.99',  sub: 'A$99.99'  },  // 3 Month
    '48534392832100': { oneTime: 'A$199.90', sub: 'A$199.90' },  // 6 Month
    '48534392864868': { oneTime: 'A$399.90', sub: 'A$399.90' }   // 12 Month
  };

  var currentVariantId = null;

  function applyPrices(variantId) {
    var priceData = variantPrices[variantId];
    if (!priceData) return;

    // Update hidden cart inputs
    document.querySelectorAll('input[name="id"]').forEach(function (input) {
      input.value = variantId;
    });

    // Update all .money elements inside Seal's widget
    document.querySelectorAll('.sls-container .money, [class*="sls-"] .money').forEach(function (el) {
      if (el.closest('.sls-savings-badge')) return;
      if (el.closest('.sls-discount-badge')) return;

      var isOneTime = !!el.closest('[data-one-time-option]') ||
                      !!el.closest('.sls-one-time-option') ||
                      !!el.closest('.sls-option-container.sls-one-time');

      el.textContent = isOneTime ? priceData.oneTime : priceData.sub;
    });

    // Direct selectors from your DevTools
    document.querySelectorAll('.sls-selling-plan-group-first-line .sls-price .money').forEach(function (el) {
      el.textContent = priceData.sub;
    });
    document.querySelectorAll('.sls-one-time-price .money, .sls-total-price .money').forEach(function (el) {
      el.textContent = priceData.oneTime;
    });
  }

  function syncVariant(variantId) {
    if (!variantId) return;
    variantId = String(variantId);
    currentVariantId = variantId;

    // Update data-variant-id attributes
    document.querySelectorAll('[data-variant-id]').forEach(function (el) {
      el.dataset.variantId = variantId;
    });

    // Run immediately
    applyPrices(variantId);

    // Run again after short delays to catch Seal re-rendering after the DOM morph
    setTimeout(function () { applyPrices(variantId); }, 100);
    setTimeout(function () { applyPrices(variantId); }, 300);
    setTimeout(function () { applyPrices(variantId); }, 600);
  }

  // Watch for Seal's widget re-rendering via MutationObserver
  // This fires whenever Seal changes any .money element and re-applies our prices
  var slsContainer = null;

  function attachObserver() {
    var container = document.querySelector('.sls-container');
    if (!container || container === slsContainer) return;
    slsContainer = container;

    var observer = new MutationObserver(function () {
      if (currentVariantId) {
        applyPrices(currentVariantId);
      }
    });

    observer.observe(container, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  // After variant:update fires (post-fetch, post-morph), re-apply prices
  document.addEventListener('variant:update', function (event) {
    var id = event.detail && event.detail.resource && event.detail.resource.id;
    if (id) syncVariant(id);
    // Re-attach observer in case Seal's container was replaced by the morph
    setTimeout(attachObserver, 200);
  });

  // On Duration button click (instant)
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target) return;
    if (target.tagName === 'INPUT' && target.type === 'radio' && target.dataset.variantId) {
      syncVariant(target.dataset.variantId);
    }
  });

  // Attach observer on page load
  document.addEventListener('DOMContentLoaded', attachObserver);
  setTimeout(attachObserver, 1000);

})();
